import { LoginStatus, ProductCode } from '@dev/ee-api/ee-api-models';
import { ActionCreator } from 'redux';
import { ApplicationState } from '..';

import {
    LoginUserAction,
    LoginUserErrorAction,
    LoginUserSuccessAction,
    SessionAuthFailedAction,
    SessionAuthStartAction,
    SessionAuthSuccessAction,
    SessionAuthWithDisposableTokenAction,
    SessionNewPasswordErrorAction,
    SessionNewPasswordFinishAction,
    SessionNewPasswordStartAction,
    SessionState,
    ShowNewPasswordAction,
} from './types';

export const SessionStartAuth: ActionCreator<SessionAuthStartAction> = (): SessionAuthStartAction => ({
    type: '@@session/AUTH_START',
    payload: { authorizationInProgress: true },
});

export const SessionFailedAuth: ActionCreator<SessionAuthFailedAction> = (): SessionAuthFailedAction => ({
    type: '@@session/AUTH_ERROR',
    payload: { authorizationInProgress: false, authorized: false },
});

export const SessionSuccessAuth: ActionCreator<SessionAuthSuccessAction> = (): SessionAuthSuccessAction => ({
    type: '@@session/AUTH_SUCCESS',
    payload: { authorizationInProgress: false, authorized: true },
});

export const SessionStartAuthWithDisposableToken: ActionCreator<SessionAuthWithDisposableTokenAction> = (
    token: string
): SessionAuthWithDisposableTokenAction => ({
    type: '@@session/DISPOSABLE_TOKEN_AUTH_START',
    payload: {
        token,
    },
});

export const LoginUser: ActionCreator<LoginUserAction> = (
    UserName: string,
    Password: string,
    TwoFactorAuthCode?: string,
    rememberMe?: boolean,
    AuthProviderToken?: string,
    GoogleIdToken?: string,
    Plan?: ProductCode
): LoginUserAction => ({
    type: '@@session/LOGIN',
    payload: {
        UserName,
        Password,
        TwoFactorAuthCode,
        rememberMe,
        AuthProviderToken,
        GoogleIdToken,
        Plan,
    },
    meta: {
        thunk: true,
    },
});

export const LoginUserSuccess: ActionCreator<LoginUserSuccessAction> = (
    Status: LoginStatus,
    meta: Record<string, unknown>
): LoginUserSuccessAction => ({
    type: '@@session/LOGIN_SUCCESS',
    payload: {
        Status,
    },
    meta,
});

export const LoginUserError: ActionCreator<LoginUserErrorAction> = (
    errorParams: Record<string, string>,
    meta: Record<string, unknown>
): LoginUserErrorAction => ({
    type: '@@session/LOGIN_ERROR',
    payload: {
        errorParams,
    },
    meta,
    error: true,
});

export const SetNewPassword: ActionCreator<SessionNewPasswordStartAction> = (password: string, token: string) => ({
    type: '@@session/SEND_NEW_PASSWORD_START',
    payload: {
        password,
        token,
    },
    meta: {
        thunk: true,
    },
});

export const SetNewPasswordSuccess: ActionCreator<SessionNewPasswordFinishAction> = (
    meta: Record<string, unknown>
) => ({
    type: '@@session/SEND_NEW_PASSWORD_SUCCESS',
    meta,
});

export const SetNewPasswordFailed: ActionCreator<SessionNewPasswordErrorAction> = (
    meta: Record<string, unknown>,
    error: string
) => ({
    type: '@@session/SEND_NEW_PASSWORD_ERROR',
    meta,
    error: true,
    payload: {
        errorMsg: error,
    },
});

export const ShowNewPasswordScreen: ActionCreator<ShowNewPasswordAction> = () => ({
    type: '@@session/SHOW_RESET_PASSWORD_FORM',
});

export const getSessionStore = (store: ApplicationState): SessionState => store.session;
